import React, { useContext, useMemo, useState } from "react";
import { useMediaQuery } from '@mui/material';
import currentLanguage from '../services/language';

let mapHeight = '100vh';

const TourContext = React.createContext();

export function useToursContext() {
    return useContext(TourContext);
}

export function TourProvider({ children }) {
    // const [map, setMap] = useState()
    const tags =
        currentLanguage() === 'bg' ?
            [
                { id: 2, name: 'винарни', type: 'winery' },
                { id: 3, name: 'природни обекти', type: 'nature' },
                { id: 1, name: 'културни обекти', type: 'culture' },
            ]
            :
            [
                { id: 2, name: 'wineries', type: 'winery' },
                { id: 3, name: 'natural landmarks', type: 'nature' },
                { id: 1, name: 'cultural landmarks', type: 'culture' },
            ];

    const [isTourDrawerOpened, setIsTourDrawerOpened] = useState(false)
    const [clickedTourId, setClickedTourId] = useState(0)
    const [clickedTagValue, setClickedTagValue] = useState([...tags?.filter(tag => tag.id === 2)]);
    const [noTagsClicked, setNoTagsClicked] = useState(true);
    const matches = useMediaQuery('(min-width:600px)');

    function onTourClickedHandler(id) {
        setClickedTourId(id)
        setIsTourDrawerOpened(true)
    }

    function showRandomTour(areToursFetchedAfterMount, mapTours) {
        if (matches && areToursFetchedAfterMount && mapTours?.length > 0 && !isTourDrawerOpened && clickedTagValue.length === 0 && noTagsClicked) {
            let randomTour = mapTours[Math.floor(Math.random() * mapTours.length)];
            randomTour?.id && onTourClickedHandler(randomTour.id)
        }
    }

    useMemo(() => {
        if (document.getElementById('root')) {
            const container = document.getElementById('root');
            let height = container.style.height;
            if (height) {
                mapHeight = height;
            }
        }
    }, [])

    const value = {
        // map, setMap,
        isTourDrawerOpened, setIsTourDrawerOpened,
        clickedTourId, setClickedTourId,
        clickedTagValue, setClickedTagValue,
        mapHeight, onTourClickedHandler,
        noTagsClicked, setNoTagsClicked,
        showRandomTour, tags
    };

    return (
        <TourContext.Provider value={value}>
            {children}
        </TourContext.Provider>
    )
}